
<template>
    
        <mars-view :style="{'max-height': maxHeight}" :class="{'note-content': true, 'isFold': isFold}"><mars-view class="title">
        {{ note.title }}
    </mars-view><mars-view v-if="note.content" id="content" class="content"><template><mars-view class="answer-main" v-html="note.content.content_rich_text"></mars-view></template><mars-view v-if="isFold" class="show-all-area" @click.native="showAll"><mars-view class="show-all-look"></mars-view><mars-view class="show-all-btn"><mars-view>展开剩余</mars-view><mars-view class="arrow-icon"></mars-view></mars-view></mars-view></mars-view><mars-view v-if="note.create_time" class="date">
        {{ note.create_time | filterDate }}
    </mars-view></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import dayjs from 'dayjs';
export default {
  name: 'noteContent',
  props: {
    note: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    note: {
      handler(note) {
        if (!note || !note.content || !note.content.content_rich_text) {
          return;
        }
        // 去掉空 p 标签
        this.note.content.content_rich_text = note.content.content_rich_text.replace(/<p><\/p>/g, '');
        setTimeout(() => {
          const app = getApp();
          const query = app.$api.createSelectorQuery();
          query.select('#content').boundingClientRect().exec((res = []) => {
            const winData = this.$api.getSystemInfoSync();
            let pageHeight = winData && winData.screenHeight;
            if (res[0] && pageHeight) {
              this.isFold = res[0].top + res[0].height > pageHeight * 1.5;
              if (this.isFold) {
                this.maxHeight = (this.isFold ? pageHeight * 1.5 - res[0].top : res[0].height) + 'px';
              }
            }
          });
        }, 500);
      },
      immediate: true
    }
  },
  filters: {
    filterDate(date) {
      return dayjs(date * 1000).format('YYYY-MM-DD');
    }
  },
  data() {
    return {
      isFold: false,
      maxHeight: ''
    };
  },
  methods: {
    showAll() {
      this.isFold = false;
      this.maxHeight = '100%';
    }
  }
};
</script>

<style scoped>
.note-content {
  position: relative;
  padding: 0.23rem 0 0.2rem;
}
.note-content.isFold {
  overflow: hidden;
}
.note-content .title {
  color: #1e1f24;
  font-family: PingFang SC;
  font-size: 0.18rem;
  font-weight: 500;
  line-height: 1.2;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  padding: 0 0.17rem;
}
.note-content .content {
  padding: 0.08rem 0.17rem 0;
}
.note-content .content .show-all-area {
  width: 100vw;
  height: 2rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.7) 64.25%, #fff 86.85%);
  background-size: 100% 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.note-content .content .show-all-area .show-all-look {
  width: 100%;
  height: 100%;
}
.note-content .content .show-all-area .show-all-btn {
  width: 100%;
  position: absolute;
  bottom: 0;
  font-size: 0.16rem;
  color: #1e1f24;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.2rem;
}
.note-content .content .show-all-area .show-all-btn .arrow-icon {
  height: 0.16rem;
  width: 0.16rem;
  margin-left: 0.03rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/note/icon.png') no-repeat center center / 100% 100%;
}
.note-content .content .answer-main {
  color: #1e1f24;
  font-size: 0.16rem;
  font-weight: 400;
  line-height: 0.31rem;
}
.note-content .date {
  margin-top: 0.2rem;
  color: #858585;
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 1;
  padding: 0 0.17rem;
}

</style>
